import { Link, Typography } from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';

import { ORIGIN } from '../constants/Router';

const textConfig = {
  variant: 'body2',
};

export const CreateAccountLink = props => {
  return (
    <Typography {...textConfig} {...props}>
      Don't have an account?{' '}
      <Link
        component={RouterLink}
        to={{
          pathname: `/welcome`,
          search: '?origin=' + ORIGIN.CREATE_ACCOUNT_LINK,
        }}
        {...textConfig}
      >
        Create new
      </Link>
    </Typography>
  );
};

CreateAccountLink.propTypes = {
  'data-testid': PropTypes.string,
};
